module.exports = {"title":"Parabéns! Sua VeloeTag foi ativada com sucesso.","paragraph":"Agora, você precisa colar a VeloeTag no seu veículo, veja na próxima tela. É simples e rápido.","submitButton":"Continuar"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/ActivationSuccess/data.json
// module id = 2189
// module chunks = 0